<template>
  <div id="pageTable" class="mainView">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-btn color="primary" dark slot="activator" @click="openModalPoint">포인트</v-btn>
        <v-btn color="primary" dark slot="activator" @click="giveCoupon">쿠폰발급</v-btn>
        <v-btn color="primary" dark slot="activator" @click="sendingSMS">SMS전송</v-btn>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <div class="flex xs12 sm2">
              <v-select
                :items="[{
                          text: '승객 고유번호',
                          value: 'id'
                        },
                        {
                          text: '전화번호',
                          value: 'phoneNumber'
                        },
                        {
                          text: '이름',
                          value: 'name'
                        },
                        {
                          text: '성별',
                          value: 'gender'
                        },
                        {
                          text: '사용상태',
                          value: 'state'
                        }]"
                name="header"   
                v-model="searchFormModel.filter"        
                label="header"
              ></v-select>
              </div>

              <div class="flex xs12 sm2" v-show="searchFormModel.filter === 'gender'">
                <v-select
                        :items="gender"
                        label="선택"
                        item-text="text"
                        item-value="state"
                        single-line
                        v-model="searchFormModel.filterText"
                >
                </v-select>
              </div>

              <div class="flex xs12 sm2" v-show="searchFormModel.filter === 'state'">
                <v-select
                        :items="state"
                        label="선택"
                        item-text="text"
                        item-value="state"
                        single-line
                        v-model="searchFormModel.filterText"
                >
                </v-select>
              </div>

              <v-text-field
                      v-show="searchFormModel.filter !== 'state' && searchFormModel.filter !== 'gender'"
                      flat
                      solo
                      prepend-icon="search"
                      placeholder="Type something"
                      v-model="searchFormModel.filterText"
                      hide-details
                      class="hidden-sm-and-down"
                      @keyup.enter="searchFilter"
              ></v-text-field>
              <v-btn icon @click="searchFilter">
                <v-icon>filter_list</v-icon>
              </v-btn>         
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :items="complex.items"
                :rows-per-page-items="[10,25,50]"
                class="elevation-1"
                item-key="id"
                must-sort
                :total-items="totalItems"
                :loading="loading"
                :pagination.sync="pagination"
                select-all
                v-model="complex.selected"
                >
                <template slot="items" slot-scope="props">    
                <td>
                  <v-checkbox
                    primary
                    hide-details
                    v-model="props.selected"
                  ></v-checkbox>
                </td>               
                  <td class="text-sm-center"><a @click="openDetail(props.item.id)">{{ props.item.id }}</a></td>
                  <td class="text-sm-center" >{{ props.item.name }}</td>
                  <td class="text-sm-center" >{{ props.item.birthDay }}</td>
                  <td class="text-sm-center" >{{ props.item.gender === 'M' ? '남자' : '여자' }}</td>
                  <td class="text-sm-center" >{{ props.item.phoneNumber }}</td>
                  <td class="text-sm-center" >{{ props.item.regDate }}</td>
                  <td class="text-sm-center">
                    <v-select
                      :items="state"
                      label="State"
                      item-text="text"
                      item-value="state"
                      single-line
                      :value="props.item.state"
                      @change="changeState(props.item.id, $event)">
                    </v-select>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          
          <v-dialog v-model="coupon.dialog" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="headline">쿠폰 조회</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field 
                        label="이름"
                        :value="couponDetail.name"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        label="쿠폰 종류"
                        :items="couponList"
                        v-model="e7"
                        item-text="title"
                        item-value="id"
                        @change="changeCouponList($event)"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer>
                </v-spacer>
                <v-btn color="blue darken-1" flat @click="createCoupon">발급</v-btn>
                <v-btn color="blue darken-1" flat @click="closeDialogCoupon">취소</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>

      <ModalPoint></ModalPoint>
    </v-container>
  </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import State  from '@/api/state';
import Gender  from '@/api/gender';
import ModalPoint from '../../components/modal/point/modal-point';

export default {
  components: {
    VWidget, ModalPoint
  },
  data () {
    return {
      pagination: {
        descending: true,
        rowsPerPage: 10,
        page: 1
      },
      searchFormModel: {
        filter: 'id',
        filterText: ''
      },
      totalItems: 0,
      loading: true,
      complex: {
        selected: [],
        headers: [
          {
            text: '승객 고유번호',
            value: 'id',
            align: 'center'
          },
          {
            text: '이름',
            value: 'name',
            sortable: false,
            align: 'center'
          },
          {
            text: '생년월일',
            value: 'birthDay',
            sortable: false,
            align: 'center'
          },
          {
            text: '성별',
            value: 'gender',
            sortable: false,
            align: 'center'
          },
          {
            text: '휴대전화번호',
            value: 'phoneNumber',
            align: 'center'
          },
          {
            text: '가입일',
            value: 'regDate',
            align: 'center'
          },
          {
            text: '사용 상태',
            value: 'state',
            align: 'center'
          },
        ],
        items: []
      },
      coupon: {
        dialog: false
      },
      couponDetail: {
        name: ''
      },
      e7: null,  
      state: State,
      gender: Gender,
      couponList: [],
      totalBlameCount: 0
    };
  },
  watch: {
    pagination: {
      handler () {
        if (top.getApp.prevPageName === 'PassengerMemberPage') {
          if(top.getApp.prevPagination != null) {
            this.pagination = top.getApp.prevPagination;
          }

          if(top.getApp.prevSearchFormModel != null) {
            this.searchFormModel = top.getApp.prevSearchFormModel;
          }

          top.getApp.clearPrevData();
        }

        this.banbanCreated();
      },
      deep: true
    },
    'searchFormModel.filter' () {
        this.searchFormModel.filterText = '';
    }
  },
  mounted () {
    for (let i = 0; i < this.$parent.$children.length; i++) {
      if (this.$parent.$children[i].chkAutoReload != null) {
        this.$parent.$children[i].chkAutoReload();
      }
    }

    this.loadCoupons();
  },
  methods: {
    banbanCreated () {
      this.loading = true;

      const parameters = {
        method: 'searchPassengers',
        pageNum: this.pagination.page - 1,
        pageSize: this.pagination.rowsPerPage,
        sortName: this.pagination.sortBy,
        order: this.pagination.descending == true ? 'desc' : 'asc',
        filter: this.searchFormModel.filter,
        filterText: this.searchFormModel.filterText
      };
      this.$store.dispatch('banbanAPI', parameters)
        .then(({ data }) => {
          if (data.statusCode != null && data.statusCode != '200'){
            throw data.message;
          }

          this.complex.items = data.content;
          this.totalItems = data.totalElements;
          this.loading = false;
          top.getApp.progress.dialog = false;
        })
        .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
          top.getApp.progress.dialog = false;
        });
    },
    loadCoupons () {
      const parameters = {
        method: 'searchCoupons',
        pageNum: 0,
        pageSize: 50,
        sortName: 'id',
        order: 'desc',
      };
      this.$store.dispatch('banbanAPI', parameters)
        .then(({ data }) => {
          this.couponList = data.content;
        });
    },
    changeState (id, state) {
      const prameters = {
        method: 'changeStatePassenger',
        'id': id,
        'userState': state
      };
      this.$store.dispatch('banbanAPI', prameters)
        .then(({ data }) => {
          top.getApp.progress.dialog = false;
        })
        .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
          top.getApp.progress.dialog = false;
        });
    },
    openDetail (id) {
      top.getApp.addPrevData('PassengerMemberPage', this.pagination, this.searchFormModel);
      this.$router.push('/member/passengerMemberDetail/' + id);
    },
    openModalPoint () {
      if (this.complex.selected.length === 0) {
        alert('포인트 처리할 대상을 선택하세요');
        return;
      }

      let userIds = [];
      this.complex.selected.forEach(item => {
        userIds.push(item.id);
      });

      this.$modal.show('modal-point', {userIds: userIds});
    },
    giveCoupon () {
      if (this.complex.selected.length === 0) {
        alert('쿠폰을 발급할 대상을 선택하세요');
      }
      else if (this.complex.selected.length >= 100) {
        alert('최대 100명까지 동시에 발급할 수 있습니다.');
      }
      else {
        this.coupon.dialog = true;

        if (this.complex.selected.length === 1) {
          this.couponDetail.name = this.complex.selected[0].name;
        } else {
          this.couponDetail.name = this.complex.selected[0].name + ' 외 ' + String(this.complex.selected.length - 1) + '명';
        }
      }
    },
    closeDialogCoupon () {
      this.coupon.dialog = false;
    },
    createCoupon () {
      let prameters = {};
      if (this.complex.selected.length === 1) {
        prameters = {
          method: 'createCouponHistories',
          'userId': this.complex.selected[0].id,
          'userType': 'P',
          'coupon': {
            'id': this.couponDetail.couponId
          }
        };
      }
      else {
        let userIds = [];
        for (let i = 0; i < this.complex.selected.length; i++) {
          userIds.push(this.complex.selected[i].id);
        }
        
        prameters = {
          method: 'createCouponHistories',
          'userIds': userIds,
          'userType': 'P',
          'coupon': {
            'id': this.couponDetail.couponId
          }
        };
      }
      
      this.$store.dispatch('banbanAPI', prameters)
        .then(({ data }) => {
          alert('발급이 완료되었습니다');
          this.coupon.dialog = false;
          top.getApp.progress.dialog = false;
        })
        .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
          top.getApp.progress.dialog = false;
        });
    },
    changeCouponList (state) {
      this.couponDetail.couponId = state;
    },
    searchFilter () {
      this.banbanCreated();
    },
    sendingSMS () {
      if (this.complex.selected.length === 0) {
        alert('SMS 전송할 대상을 선택하세요');
      }
      else if (this.complex.selected.length >= 1000) {
        alert('최대 1000명까지 동시에 전송할 수 있습니다.');
      }
      else {
        var phoneNumber;
        for (let i = 0; i < this.complex.selected.length; i++) {
          if( i == 0 ) {
            phoneNumber = this.complex.selected[i].phoneNumber;
          } else {
            phoneNumber += ',' + this.complex.selected[i].phoneNumber;
          }
        }

        top.getApp.addPrevData('PassengerMemberPage', this.pagination, this.searchFormModel);
        this.$router.push('/sms/sendingSMS/' + phoneNumber);
        
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/member/PassengerMember.vue